import React, { useState, useRef } from "react";
import { createUser } from "../../../services/UserService";
import { toast } from "react-toastify";
import Select from "react-select";
import ROLES from "./roles";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

export const AdicionarUsuarioModal = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [roles, setRoles] = useState();
  const inputName = useRef("");
  const inputEmail = useRef("");
  const inputPassword = useRef("");
  const [loading, setLoading] = useState(false);
  const [comission, setComission] = useState();
  const toggle = () => setIsOpen(!isOpen);

  function handleSubmit(e) {
    setLoading(true);
    e.preventDefault();

    const data = {
      name: inputName.current.value,
      email: inputEmail.current.value,
      password: inputPassword.current.value,
      roles: [roles.key],
      comission: comission ? comission : 0,
    };

    try {
      createUser(data)
        .then((response) => {
          props.listUsers(false);
          toast.success(response);
          setIsOpen(false);
        })
        .catch((error) => {
          if (error.response.status === 422) toast.error(error.response.data);
          else toast.error("Não foi possível adicionar usuário");
        });

      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }

  const formatRoleLabels = (role) => (
    <>
      <span>{role.value}</span>
    </>
  );

  return (
    <>
      {/* Botão de Trigger (Redondo + Pulse no padrão Alcon Auto) */}
      <button 
        type="button"
        onClick={() => setIsOpen(true)}
        className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center onboarding-pulse shadow"
        style={{ width: '54px', height: '54px', minWidth: '54px' }}
        title="Novo Funcionário"
      >
        <i className="fa fa-plus fs-5"></i>
      </button>

      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        backdrop="static"
        size="lg"
        centered
      >
        {/* Cabeçalho do Modal alinhado ao padrão de Configurações */}
        <ModalHeader toggle={toggle} className="border-0 pb-0 pt-4 px-4">
          <h5 className="fw-bold text-dark mb-0">Cadastro de Funcionário</h5>
          <p className="text-muted small mb-0 mt-1">Insira as credenciais de acesso e regras de comissionamento</p>
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="px-4 pt-3 pb-4">
            
            {/* SEÇÃO 1: ACESSO E IDENTIFICAÇÃO (CARD LIGHT) */}
            <div className="bg-light p-3 rounded-4 border mb-4">
              <div className="d-flex align-items-center mb-3 text-primary">
                <i className="fas fa-user-shield me-2"></i>
                <span className="fw-bold text-muted small text-uppercase" style={{ fontSize: '0.72rem' }}>
                  Acesso e Identificação
                </span>
              </div>
              
              <div className="row g-3">
                <div className="col-lg-6">
                  <label className="form-label small fw-bold text-dark">Nome do Colaborador</label>
                  <input
                    id="userName"
                    ref={inputName}
                    type="text"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    placeholder="Ex: João da Silva"
                    required
                  />
                </div>

                <div className="col-lg-6">
                  <label className="form-label small fw-bold text-dark">E-mail de Acesso</label>
                  <input
                    id="userEmail"
                    ref={inputEmail}
                    type="email"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    placeholder="exemplo@alcon.com"
                    required
                  />
                </div>

                <div className="col-lg-12">
                  <label className="form-label small fw-bold text-dark">Senha de Acesso</label>
                  <input
                    id="userPass"
                    autoComplete="new-password"
                    ref={inputPassword}
                    type="password"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    placeholder="Crie uma senha segura para o colaborador"
                    required
                  />
                </div>
              </div>
            </div>

            {/* SEÇÃO 2: CARGO & COMISSÃO (CARD WHITE COM SOMBRA) */}
            <div className="bg-white p-3 rounded-4 border shadow-sm">
              <div className="d-flex align-items-center mb-3 text-primary">
                <i className="fas fa-briefcase me-2"></i>
                <span className="fw-bold text-muted small text-uppercase" style={{ fontSize: '0.72rem' }}>
                  Cargo & Comissionamento
                </span>
              </div>

              <div className="row g-3 align-items-end">
                {/* Seleção do Cargo */}
                <div className="col-lg-8">
                  <label className="form-label small fw-bold text-dark mb-2 d-block">Função / Cargo</label>
                  <Select
                    id="userRoles"
                    onChange={setRoles}
                    name="roles"
                    classNamePrefix="select"
                    options={ROLES}
                    formatOptionLabel={formatRoleLabels}
                    className="basic-multi-select"
                    placeholder="Selecione o perfil do usuário..."
                    required
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "8px",
                        borderWidth: "2px",
                        minHeight: "45px",
                        borderColor: "#dee2e6",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: "#0d6efd"
                        }
                      })
                    }}
                  />
                </div>

                {/* Entrada da Comissão */}
                <div className="col-lg-4 text-center">
                  <label className="form-label small fw-bold text-dark mb-2 d-block">Comissão %</label>
                  <div className="d-flex justify-content-center">
                    <input
                      id="userComission"
                      onChange={(e) => setComission(e.target.value)}
                      value={comission}
                      className="form-control form-control-lg border-2 text-center fw-bold rounded-3"
                      style={{ width: "6rem", height: "45px", fontSize: "1.1rem" }}
                      type="number"
                      placeholder="0"
                      max={100}
                      min={0}
                      maxLength={2}
                    />
                  </div>
                </div>
              </div>
            </div>

          </ModalBody>

          {/* Rodapé Alinhado (Sem bordas divisórias e com botões consistentes) */}
          <ModalFooter className="border-0 pt-2 px-4 pb-4">
            {!loading ? (
              <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end">
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  className="btn btn-outline-secondary btn-lg fw-bold rounded-3 px-4 order-1 order-sm-0"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm px-4"
                  style={{ minWidth: '160px' }}
                >
                  <i className="fas fa-save me-2"></i>
                  Cadastrar
                </button>
              </div>
            ) : (
              <div className="w-100 text-center py-2">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
              </div>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
};

export default AdicionarUsuarioModal;